import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const RetryIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <path d="M10 5.00008V1.66675L5.83334 5.83342 10 10.0001V6.66675c2.7583 0 5 2.24167 5 4.99995 0 2.7584-2.2417 5-5 5-2.75833 0-5-2.2416-5-5H3.33334c0 3.6834 2.98333 6.6667 6.66666 6.6667 3.6833 0 6.6667-2.9833 6.6667-6.6667 0-3.68328-2.9834-6.66662-6.6667-6.66662Z" />
  </Icon>
);

export default memo(RetryIcon);
